(<template>
  <article class="folkeregister-consent">
    <button v-if="isPage"
            class="folkeregister-consent__skip-btn"
            @click="addConsentPopupCounter('skip')">{{ $gettext('Skip') }}</button>
    <div class="folkeregister-consent__icon"></div>
    <h3 class="folkeregister-consent__subtitle">{{ $gettext('Consent for retrieving information') }}</h3>
    <p class="folkeregister-consent__description">{{ descriptionText }}</p>
    <terms-check :preselected-value="acceptedTerms"
                 :item-text="termsText"
                 class="folkeregister-consent__checkbox"
                 @checkboxvaluechanged="handleTermsChange" />
    <button class="sk-btn sk-btn--default folkeregister-consent__btn"
            :disabled="!acceptedTerms"
            @click="confirmConsent">{{ $gettext('Continue') }}</button>
  </article>
</template>)

<script>
  import {mapGetters} from 'vuex';

  export default {
    data() {
      return {
        acceptedTerms: false,
        closedByRouteChange: false
      };
    },
    computed: {
      ...mapGetters('UserInfoStore', [
        'folkeregisterConsentStatus',
        'folkeregisterConsentPopupCounter'
      ]),
      isPage() { return this.$route.name === 'ServerWizardFolkeregister'; },
      descriptionText() {
        const template = this.$gettext('To continue receiving on-site assignment requests from %{domain}, we need your consent to retrieve data from the National Population Register. Please accept the National Population Register’s terms and conditions if you wish to receive on-site assignments through %{domain}.');
        return this.$gettextInterpolate(template, {domain: this.$getString('domainData', 'platformName')});
      },
      termsText() {
        const termsLink = this.$getString('domainData', 'termLink');
        if (!termsLink) return this.$gettext('I accept the Terms and Conditions');
        const template = this.$gettext('I accept <a class="sk-link" href="%{termsLink}" target="_blank">Terms and Conditions</a>');
        return this.$gettextInterpolate(template, {termsLink});
      },
    },
    watch: {
      $route() {
        this.closedByRouteChange = true;
      }
    },
    methods: {
      handleTermsChange(value) {
        this.acceptedTerms = value;
      },
      redirectToDashboard() {
        this.$router.replace(this.$makeRoute({name: 'ServerHome'}));
      },
      addConsentPopupCounter(actionType) {
        const params = {
          folkeregisterConsent: {
            folkeregisterConsentStatus: this.folkeregisterConsentStatus,
            folkeregisterConsentPopupCounter: this.folkeregisterConsentPopupCounter + 1,
          }
        };
        this.$store.dispatch('sendFolkeregisterConsent', params).then(() => {
          if (actionType === 'skip') {
            this.redirectToDashboard();
          }
        });
      },
      confirmConsent() {
        const params = {
          folkeregisterConsent: {
            folkeregisterConsentStatus: 'accepted',
            folkeregisterConsentPopupCounter: this.folkeregisterConsentPopupCounter + 1,
          }
        };
        this.$store.dispatch('sendFolkeregisterConsent', params).then(() => {
          this.closedByRouteChange = true;
          if (this.isPage) {
            this.redirectToDashboard();
          } else {
            this.$store.dispatch('ModalStore/closeModal');
          }
        });
      }
    },
    beforeDestroy() {
      if (!this.closedByRouteChange) {
        this.addConsentPopupCounter('close');
      }
    }
  };
</script>

<style scoped>
  .folkeregister-consent {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: -15px;
    padding: 0 30px 30px;
    background-color: #fff;
    text-align: center;
  }

  .folkeregister-consent__skip-btn {
    margin: 24px 0 0 auto;
  }

  .folkeregister-consent__icon {
    width: 80px;
    height: 80px;
    margin: 24px auto;
    background-image: url(~@assets/imgs/salita/undefined_imgs/folkeregister_icon.svg);
    background-position: center center;
    background-repeat: no-repeat;
  }

  .folkeregister-consent__subtitle {
    color: var(--black-700);
    font-size: 20px;
    text-align: center;
  }

  .folkeregister-consent__description {
    margin: 8px 0 24px 0;
    color: var(--black-700);
  }

  .folkeregister-consent__checkbox {
    width: auto;
  }

  .folkeregister-consent__btn {
    width: 200px;
    margin: 24px 0 0;
    padding: 0 12px;
  }
</style>
